import GameNameConfigType from '../../../../common/scripts/Config/GameNameConfigType';
import SupportLanguage from '../../../../common/scripts/I18n/SupportLanguage';

const gameNameConfig: GameNameConfigType = {
    [SupportLanguage.ENG]: 'MSlot',
    [SupportLanguage.SCH]: 'MSlot',
    [SupportLanguage.TCH]: 'MSlot',
    [SupportLanguage.VI]: 'MSlot',
    [SupportLanguage.KR]: 'MSlot',
    [SupportLanguage.JP]: 'MSlot',
    [SupportLanguage.PT]: 'MSlot',
    [SupportLanguage.TH]: 'MSlot',
    [SupportLanguage.ID]: 'MSlot',
    [SupportLanguage.ES]: 'MSlot',
    [SupportLanguage.FIL]: 'MSlot',
    [SupportLanguage.MS]: 'MSlot',
    [SupportLanguage.HI]: 'MSlot',
    [SupportLanguage.TR]: 'MSlot',
    [SupportLanguage.RU]: 'MSlot',
    [SupportLanguage.BN]: 'MSlot',
};

export default gameNameConfig;
